import moment from 'moment';
import { Trad } from "./components/";
import * as Compat from './Compat';

export class CData {
    public Data = new Date(Date.now());

    private _Anno: number = 0;
    private _Mese: number = 0;
    private _Giorno: number = 0;
    private _Ora: number = 0;
    private _Minuti: number = 0;
    private _Secondi: number = 0;
    private _Millisecondi: number = 0;

    get Anno(): number {
        return this._Anno;
    }
    set Anno(anno: number) {
        this._Anno = anno;
        this.InizializzaData();
    }

    get Mese(): number {
        return this._Mese;
    }
    set Mese(mese: number) {
        this._Mese = mese;
        this.InizializzaData();
    }

    get Giorno(): number {
        return this._Giorno;
    }
    set Giorno(giorno: number) {
        this._Giorno = giorno;
        this.InizializzaData();
    }

    get Ora(): number {
        return this._Ora;
    }
    set Ora(ora: number) {
        this._Ora = ora;
        this.InizializzaData();
    }

    get Minuti(): number {
        return this._Minuti;
    }
    set Minuti(minuti: number) {
        this._Minuti = minuti;
        this.InizializzaData();
    }

    get Secondi(): number {
        return this._Secondi;
    }
    set Secondi(secondi: number) {
        this._Secondi = secondi;
        this.InizializzaData();
    }

    get Millisecondi(): number {
        return this._Millisecondi;
    }
    set Millisecondi(millisecondi: number) {
        this._Millisecondi = millisecondi;
        this.InizializzaData();
    }

    constructor(data?: Date, soloData?: boolean) {

        this.InizializzaProprieta(data);

        if (soloData != undefined && soloData) {
            this._Ora = 0;
            this._Minuti = 0;
            this._Secondi = 0;
            this._Millisecondi = 0;
        }

        this.InizializzaData();
    }

    private InizializzaData() {
        this.SetData(this._Anno, this._Mese, this._Giorno, this._Ora, this._Minuti, this._Secondi, this._Millisecondi);
    }

    private InizializzaProprieta(data?: Date) {
        if (data != undefined) {
            this._Anno = data.getUTCFullYear();
            this._Mese = data.getUTCMonth() + 1; //Noi ci salviamo i mesi come i cristiani, dove gennaio è l'1
            this._Giorno = data.getUTCDate();
            this._Ora = data.getUTCHours();
            this._Minuti = data.getUTCMinutes()
            this._Secondi = data.getUTCSeconds();
            this._Millisecondi = data.getUTCMilliseconds();
        } else {
            this._Anno = new Date().getUTCFullYear();
            this._Mese = new Date().getUTCMonth() + 1; //Noi ci salviamo i mesi come i cristiani, dove gennaio è l'1
            this._Giorno = new Date().getUTCDate();
            this._Ora = 0;
            this._Minuti = 0;
            this._Secondi = 0;
            this._Millisecondi = 0;
        }
    }

    public SetData(anno: number, mese: number, giorno: number, ora?: number, minuti?: number, secondi?: number, millisecondi?: number) {
        this._Anno = anno;
        this._Mese = mese;
        this._Giorno = giorno;
        if (ora != undefined)
            this._Ora = ora;
        if (minuti != undefined)
            this._Minuti = minuti;
        if (secondi != undefined)
            this._Secondi = secondi;
        if (millisecondi != undefined)
            this._Millisecondi = millisecondi;

        this.Data = new Date(Date.UTC(anno, mese - 1, giorno, ora, minuti, secondi, millisecondi)); //mese-1 perché in javascript gennaio è il mese 0
    }

    public AddAnni(numeroAnni: number): CData {
        this.Data.setUTCFullYear(this.Data.getUTCFullYear() + numeroAnni);
        this.InizializzaProprieta(this.Data);
        return this;
    }

    public AddMesi(numeroMesi: number): CData {
        this.Data.setUTCMonth(this.Data.getUTCMonth() + numeroMesi);
        this.InizializzaProprieta(this.Data);
        return this;
    }

    public AddGiorni(numeroGiorni: number): CData {
        this.Data.setUTCDate(this.Data.getUTCDate() + numeroGiorni);
        this.InizializzaProprieta(this.Data);
        return this;
    }

    public AddOre(numeroOre: number): CData {
        this.Data.setUTCHours(this.Data.getUTCHours() + numeroOre);
        this.InizializzaProprieta(this.Data);
        return this;
    }

    public AddMinuti(numeroMinuti: number): CData {
        this.Data.setUTCMinutes(this.Data.getUTCMinutes() + numeroMinuti);
        this.InizializzaProprieta(this.Data);
        return this;
    }

    public AddSecondi(numeroSecondi: number): CData {
        this.Data.setUTCSeconds(this.Data.getUTCSeconds() + numeroSecondi);
        this.InizializzaProprieta(this.Data);
        return this;
    }

    public AddMillisecondi(numeroMillisecondi: number): CData {
        this.Data.setUTCMilliseconds(this.Data.getUTCMilliseconds() + numeroMillisecondi);
        this.InizializzaProprieta(this.Data);
        return this;
    }

    public AddAnnualita(numeroAnni: number): CData {
        this.AddAnni(numeroAnni);
        this.AddGiorni(-1);
        return this;
    }


    get DataCompatta(): string {
        return moment.utc(this.Data).format("YY-MM-DD");
    }

    get DataBreve(): string {
        return moment.utc(this.Data).format("YYYY-MM-DD");
    }

    get DataEstesa(): string {
        return moment.utc(this.Data).format("YYYY-MM-DD HH:mm:ss");
    }

    get DataCompleta(): string {
        return moment.utc(this.Data).format("YYYY-MM-DD HH:mm:ss");
    }

    get DataTestoCompatta(): string {
        return moment.utc(this.Data).format("DD MMM YY");
    }

    get DataTestoBreve(): string {
        return moment.utc(this.Data).format("Do MMMM YYYY");
    }

    get DataTestoEstesa(): string {
        return moment.utc(this.Data).format("Do MMMM YYYY HH:mm:ss");
    }

    get DataTestoCompleta(): string {
        return moment.utc(this.Data).format("Do MMMM YYYY HH:mm:ss");
    }
}

export function DataValore(Data?: Date): string {
    if (Data == undefined || Data == null) {
        return "";
    }
    else {
        return moment.utc(Data).format("YYYY-MM-DD");
    }
}

export function DataValoreStringa(Data: string): string {
    if (Data == undefined || Data == null) {
        return "";
    }
    else {
        return moment.utc(Data).format("YYYY-MM-DD");
    }
}

export function DataValoreCompleta(Data?: Date): string {
    if (Data == undefined || Data == null) {
        return "";
    }
    else {
        return moment.utc(Data).format("YYYY-MM-DD HH:mm:ss");
    }
}

//export function DataValoreStringaCompleta(Data: string): string {
//    if (Data == undefined || Data == null) {
//        return "";
//    }
//    else {
//        return moment.utc(Data).format("YYYY-MM-DD HH:mm:ss");
//    }
//}

export function DataValoreTrad(Data?: Date): string {
    if (Data == undefined || Data == null) {
        return "";
    }
    else {
        return Trad.TradParam("{1-D}", [Data]);
    }
}

export function DataValoreStringaTrad(Data: string): string {
    if (Data == undefined || Data == null) {
        return "";
    }
    else {
        return Trad.TradParam("{1-D}", [moment(Data).toDate()]);
    }
}

//-----------------------------------------------------------------------------------------------

export class CDateTZLess {
    private _Year: number = 0;
    private _Month: number = 0;
    private _Day: number = 0;

    public ToDate(): Date | undefined {
        if (this._Month == 0 || this._Day == 0) {
            return undefined;
        }
        return new Date(Date.parse(this.ToString()));
    }

    public ToDateNotNull(): Date {
        if (this._Month == 0 || this._Day == 0) {
            return new CDateTZLess().ToDateNotNull();
        }
        return new Date(Date.parse(this.ToString()));
    }

    public ToData(): CData {
        return new CData(this.ToDate(), true);
    }

    public ToString(): string {
        if (this._Month == 0 || this._Day == 0) {
            return "";
        }
        return ((this._Year < 30 ? 1900 : this._Year <= 100 ? 2000 : 0) + this._Year).toString() + "-" +
            Compat.ES2017_padStart(this._Month.toString(), 2, "0") + "-" +
            Compat.ES2017_padStart(this._Day.toString(), 2, "0");
    }

    public ToTrad(): string {
        if (this._Month == 0 || this._Day == 0) {
            return "";
        }

        let D: Date | undefined = this.ToDate();

        if (D == undefined) {
            return "";
        }
        else {
            return Trad.TradParam("{1-D}", [D]);
        }
    }

    get Year(): number {
        return this._Year;
    }
    set Year(value: number) {
        this._Year = value;
    }

    get Month(): number {
        return this._Month;
    }
    set Month(value: number) {
        this._Month = value;
    }

    get Day(): number {
        return this._Day;
    }
    set Day(value: number) {
        this._Day = value;
    }

    constructor(date?: Date | string) {
        this.SetDate(date);
    }

    static Today(): CDateTZLess {
        let D = new Date(Date.now());
        let R = new CDateTZLess();
        R.Year = D.getFullYear();
        R.Month = D.getMonth() + 1;
        R.Day = D.getDate();
        return R;
    }

    public SetDate(date: Date | string | undefined): void {
        if (date == undefined) {
            this.Year = 0;
            this.Month = 0;
            this.Day = 0;
            return;
        }

        let D: Date;
        if (typeof (date) == "string") {
            D = new Date(Date.parse(date));
        }
        else {
            D = date;
        }
        this.Year = D.getFullYear();
        this.Month = D.getMonth() + 1;
        this.Day = D.getDate();
    }

    public AddYears(years: number): CDateTZLess {
        let D = moment(this.ToDate()).add(years, "years").toDate();
        this.SetDate(D);
        return this;
    }

    public AddMonths(months: number): CDateTZLess {
        let D = moment(this.ToDate()).add(months, "months").toDate();
        this.SetDate(D);
        return this;
    }

    public AddDays(days: number): CDateTZLess {
        let D = moment(this.ToDate()).add(days, "days").toDate();
        this.SetDate(D);
        return this;
    }

    private ExtractDateForComparison(date: CDateTZLess | CData | Date | string): CDateTZLess {
        let Date2: CDateTZLess;

        if (date instanceof CDateTZLess) {
            Date2 = date;
        }
        else if (date instanceof CData) {
            Date2 = new CDateTZLess();
            Date2.Year = date.Anno;
            Date2.Month = date.Mese;
            Date2.Day = date.Giorno;
        }
        else {
            Date2 = new CDateTZLess(date);
        }

        return Date2;
    }

    public IsGreaterThan(date?: CDateTZLess | Date | string, onlyDate: boolean = false): boolean | undefined {
        if (date == undefined) return undefined;
        let Date2 = this.ExtractDateForComparison(date);

        return this.ToString() > Date2.ToString();
    }

    public IsGreaterOrEqualThan(date?: CDateTZLess | CData | Date | string, onlyDate: boolean = false): boolean | undefined {
        if (date == undefined) return undefined;
        let Date2 = this.ExtractDateForComparison(date);

        return this.ToString() >= Date2.ToString();
    }

    public IsLowerThan(date?: CDateTZLess | CData | Date | string, onlyDate: boolean = false): boolean | undefined {
        if (date == undefined) return undefined;
        let Date2 = this.ExtractDateForComparison(date);

        return this.ToString() < Date2.ToString();
    }

    public IsLowerOrEqualThan(date?: CDateTZLess | CData | Date | string, onlyDate: boolean = false): boolean | undefined {
        if (date == undefined) return undefined;
        let Date2 = this.ExtractDateForComparison(date);

        return this.ToString() <= Date2.ToString();
    }

    public IsEqual(date?: CDateTZLess | CData | Date | string, onlyDate: boolean = false): boolean | undefined {
        if (date == undefined) return undefined;
        let Date2 = this.ExtractDateForComparison(date);

        return this.ToString() == Date2.ToString();
    }
}



// WEBPACK FOOTER //
// ./src/Data.tsx